import { Text } from "@chakra-ui/react";
import { IconButton } from "@chakra-ui/button";
import { Flex } from "@chakra-ui/layout";
import { Popover } from "antd";
import React, { useMemo, useState } from "react";
import { MdInfoOutline } from "react-icons/md";
import OutlineButton from "../Button/OutlineButton";
import PrimaryButton from "../Button/PrimaryButton";
import colors from "core/resources/theme/colors";

interface InfoTooltipProps {
  text: string;
  primaryButtonOnClick?: () => any;
  primaryButtonText?: string;
  closeButtonOnClick?: () => any;
  showButtons?: boolean;
  size?: number;
}

function InfoTooltip({
  text,
  primaryButtonOnClick,
  primaryButtonText,
  closeButtonOnClick,
  showButtons = true,
  size = 20,
}: InfoTooltipProps) {
  const [visible, setVisible] = useState(false);

  const content = useMemo(
    () => (
      <Flex flexDir="column" pt={2} rounded={8} maxW={210}>
        <Text mt={-2} mb={4} textAlign="justify" fontWeight="medium">
          {text}
        </Text>
        {showButtons ? (
          <Flex>
            <OutlineButton
              onClick={() => {
                closeButtonOnClick?.();
                setVisible(false);
              }}
              flex={1}
            >
              Fechar
            </OutlineButton>
            {primaryButtonText && primaryButtonOnClick ? (
              <PrimaryButton
                onClick={() => {
                  primaryButtonOnClick();
                  setVisible(false);
                }}
                flex={1}
                ml={4}
              >
                {primaryButtonText}
              </PrimaryButton>
            ) : null}
          </Flex>
        ) : null}
      </Flex>
    ),
    [
      text,
      showButtons,
      primaryButtonText,
      primaryButtonOnClick,
      closeButtonOnClick,
    ]
  );
  return (
    <>
      <Popover
        overlayClassName="antd-popover-hide-arrow"
        arrowContent={<></>}
        overlayStyle={{
          borderRadius: 12,
          zIndex: 2,
        }}
        overlayInnerStyle={{
          borderRadius: 12,
          boxShadow: "0 0 6px 2px #87878725",
        }}
        placement="bottomRight"
        color="white"
        trigger="click"
        content={content}
        onVisibleChange={setVisible}
        visible={visible}
      >
        <IconButton
          bg="none"
          display="inline"
          minWidth={"unset"}
          height={"unset"}
          aria-label="Mais informações"
          icon={<MdInfoOutline size={size} color={colors.black700} />}
          onClick={() => setVisible(true)}
        />
      </Popover>
    </>
  );
}

export default InfoTooltip;
